// Plain in-memory module flag (not persisted). It resets on every real page
// load/reload since JS modules re-execute from scratch, but survives
// client-side (React Router) navigation within the same tab session.
let hasVisitedOffersList = false;

export function markOffersListVisited() {
  hasVisitedOffersList = true;
}

export function hasOffersListBeenVisited() {
  return hasVisitedOffersList;
}
